import React from 'react';
import { useNavigate } from 'react-router';

const Notfound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8">
            <img
                src="/snappy-logo.png"
                alt=""
                aria-hidden="true"
                className="h-14 w-auto"
            />
            <h1 className="font-mono text-5xl font-semibold tabular-nums">
                404
            </h1>
            <p className="text-sm text-muted-foreground">
                This page doesn't exist. Even the snail couldn't find it.
            </p>
            <button
                onClick={async () => navigate('/')}
                className="rounded-lg bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground transition-transform hover:bg-primary/90 active:scale-[0.97]"
            >
                Back to trading
            </button>
        </div>
    );
};

Notfound.displayName = 'Notfound';
export default Notfound;
